export const countMatchingTags = (templateTags, suggestionTags) => {
  return templateTags.filter(tag => suggestionTags.includes(tag)).length;
};

export const rankMatchTemplates = (matchTemplates, suggestionTags) => {
  return matchTemplates
    .map(matchTemplate => ({
      ...matchTemplate,
      matchCount: countMatchingTags(matchTemplate.tags, suggestionTags),
    }))
    .sort((a, b) => {
      if (b.matchCount !== a.matchCount) return b.matchCount - a.matchCount;
      return a.priority - b.priority;
    })
    .map((item, index) => {
      return { ...item, active: index === 0 };
    });
};
